function escapeHtml(text) {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function applyInlineFormatting(text) {
    let result = '';
    let index = 0;
    const source = String(text);

    while (index < source.length) {
        if (source.startsWith('**', index)) {
            const end = source.indexOf('**', index + 2);
            if (end !== -1) {
                result += `<strong>${escapeHtml(source.slice(index + 2, end))}</strong>`;
                index = end + 2;
                continue;
            }
        }

        if (source[index] === '*' && !source.startsWith('**', index)) {
            const end = source.indexOf('*', index + 1);
            if (end !== -1) {
                result += `<em>${escapeHtml(source.slice(index + 1, end))}</em>`;
                index = end + 1;
                continue;
            }
        }

        const nextSpecial = source.slice(index).search(/\*/);
        if (nextSpecial === -1) {
            result += escapeHtml(source.slice(index));
            break;
        }

        result += escapeHtml(source.slice(index, index + nextSpecial));
        index += nextSpecial;
    }

    return result;
}

/** Convert Ask Lens markdown answer into HTML suitable for the Journal Quill editor. */
export function markdownToJournalHtml(markdown) {
    const lines = String(markdown || '')
        .replace(/\r\n/g, '\n')
        .split('\n');
    const parts = [];
    let listType = null;
    let listItems = [];

    const flushList = () => {
        if (!listItems.length) return;
        const tag = listType === 'ul' ? 'ul' : 'ol';
        parts.push(`<${tag}>${listItems.map(item => `<li>${item}</li>`).join('')}</${tag}>`);
        listItems = [];
        listType = null;
    };

    for (const rawLine of lines) {
        const trimmed = rawLine.trim();
        if (!trimmed) {
            flushList();
            continue;
        }

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.+)$/);
        if (headingMatch) {
            flushList();
            const level = Math.min(headingMatch[1].length, 6);
            parts.push(`<h${level}>${applyInlineFormatting(headingMatch[2])}</h${level}>`);
            continue;
        }

        const orderedMatch = trimmed.match(/^\d+\.\s+(.+)$/);
        if (orderedMatch) {
            if (listType && listType !== 'ol') flushList();
            listType = 'ol';
            listItems.push(applyInlineFormatting(orderedMatch[1]));
            continue;
        }

        const unorderedMatch = trimmed.match(/^[-*]\s+(.+)$/);
        if (unorderedMatch) {
            const formatted = applyInlineFormatting(unorderedMatch[1]);
            if (listType === 'ol' && listItems.length > 0) {
                const lastIdx = listItems.length - 1;
                const item = listItems[lastIdx];
                if (item.includes('<ul>')) {
                    listItems[lastIdx] = item.replace(/<\/ul>\s*$/, `<li>${formatted}</li></ul>`);
                } else {
                    listItems[lastIdx] = `${item}<ul><li>${formatted}</li></ul>`;
                }
                continue;
            }

            if (listType && listType !== 'ul') flushList();
            listType = 'ul';
            listItems.push(formatted);
            continue;
        }

        flushList();
        parts.push(`<p>${applyInlineFormatting(trimmed)}</p>`);
    }

    flushList();
    return parts.join('');
}
